import { render, staticRenderFns } from "./LoadEmpty.vue?vue&type=template&id=51321b35&scoped=true&"
import script from "./LoadEmpty.vue?vue&type=script&lang=ts&"
export * from "./LoadEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./LoadEmpty.vue?vue&type=style&index=0&id=51321b35&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51321b35",
  null
  
)

export default component.exports